"use strict";

module.exports = require("./is-implemented")()
	? Object.keys
	: require("./shim");



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/object/keys/index.js
// module id = 682
// module chunks = 0